let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("80iir")).then(() => parcelRequire('01dPo'));